import firebase from 'firebase'

export const SPACE_ROLES = {
    VIEWER: 20,
    COLLABORATOR: 40,
    OWNER: 60
} as const

const spacesRef = (spaceId: string) => firebase.firestore().doc(`spaces/${spaceId}`)

export const accessOptions = [
    { value: 'false', label: 'Restricted' },
    { value: 'true', label: 'Private' }
]

export type SpaceMembers = {
    displayName: string
    email: string
    photoURL: string
    uid: string
    roles: {
        a: number
    }
}

type CreateSpaceDataType = {
    organizationId: string
    org: {
        name: string
        logo: string
    }
    name: string
    description?: string
    isPrivate: boolean
    members: {
        [key: string]: SpaceMembers
    } | null
    lastUpdatedByUid: string
    createdAt: firebase.firestore.FieldValue
    createdBy: { uid: string; displayName: string; email: string }
}

export const createSpace = (spaceId: string, data: CreateSpaceDataType) => {
    return spacesRef(spaceId).set({
        ...data,
        id: spaceId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
    })
}

export const updateSpace = (spaceId: string, space: {}) => {
    return spacesRef(spaceId).update(space)
}

export const deleteSpace = (spaceId: string) => {
    return spacesRef(spaceId).delete()
}

type SharePlaybookProps = {
    id: string
    spaceId: string
    orgId: string
    uid: string
}

export const shareRecordedPlaybookToSpace = ({
    id, // <- playbookId
    spaceId,
    orgId,
    uid
}: SharePlaybookProps) => {
    return firebase
        .database()
        .ref(`/autoShareToSpaces/${orgId}/${uid}/playbook`)
        .update({ [id]: [spaceId] })
        .catch(console.error)
}

export const shareUploadedPlaybookToSpace = ({
    id, // <- batchUploadId
    spaceId,
    orgId,
    uid
}: SharePlaybookProps) => {
    return firebase
        .database()
        .ref(`/autoShareToSpaces/${orgId}/${uid}/batchUpload/${id}`)
        .transaction(value => {
            if (!value) return [spaceId]
            return [...value, spaceId]
        })
        .catch(console.error)
}
